// DO NOT EDIT -- generated from fs/services/eraser/eraser.proto

import { DeleteSegmentRequest, DeleteSessionRequest, ListOperationsRequest, OperationId } from './eraser_public.proto';
import * as fullstory_operations_v1 from '../../api/fullstoryapis/operations/v1';
import * as fullstory_users_v1 from '../../api/fullstoryapis/users/v1';
import * as protobuf from '../../../google/protobuf';

export namespace Eraser {

  export const QueryIndividualEndpoint = "/grpc/eraser.Eraser/QueryIndividual";
  /** QueryIndividual return details about an identified user, given the uid. */
  export function QueryIndividual(sender: (req: IndividualId, endpoint: string) => Promise<fullstory_users_v1.IndividualDetails>, req: IndividualId): { promise: () => Promise<fullstory_users_v1.IndividualDetails>, endpoint: string } {
    return {
      promise: () => sender(req, QueryIndividualEndpoint),
      endpoint: QueryIndividualEndpoint
    };
  }

  export const QueryUserEndpoint = "/grpc/eraser.Eraser/QueryUser";
  /**
   * QueryUser return details about an anonymous user, given the autogenerated
   * numeric ID of the user.
   */
  export function QueryUser(sender: (req: UserId, endpoint: string) => Promise<fullstory_users_v1.IndividualDetails>, req: UserId): { promise: () => Promise<fullstory_users_v1.IndividualDetails>, endpoint: string } {
    return {
      promise: () => sender(req, QueryUserEndpoint),
      endpoint: QueryUserEndpoint
    };
  }

  export const DeleteIndividualEndpoint = "/grpc/eraser.Eraser/DeleteIndividual";
  /**
   * DeleteIndividual deletes all data associated with the identified user, for
   * the given uid. Deletion includes user's properties and user's sessions.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteIndividual(sender: (req: DeleteIndividualRequest, endpoint: string) => Promise<OperationId>, req: DeleteIndividualRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIndividualEndpoint),
      endpoint: DeleteIndividualEndpoint
    };
  }

  export const RequestIndividualDeletionEndpoint = "/grpc/eraser.Eraser/RequestIndividualDeletion";
  /**
   * RequestIndividualDeletion creates the deletion request.
   * Once the request is approved with ReviewDeletion, the data is deleted.
   */
  export function RequestIndividualDeletion(sender: (req: DeleteIndividualRequest, endpoint: string) => Promise<OperationId>, req: DeleteIndividualRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, RequestIndividualDeletionEndpoint),
      endpoint: RequestIndividualDeletionEndpoint
    };
  }

  export const DeleteUserEndpoint = "/grpc/eraser.Eraser/DeleteUser";
  /**
   * DeleteUser deletes all data associated with the anonymous user, for
   * the given user_id. Deletion includes user's properties and user's sessions.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteUser(sender: (req: DeleteUserRequest, endpoint: string) => Promise<OperationId>, req: DeleteUserRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteUserEndpoint),
      endpoint: DeleteUserEndpoint
    };
  }

  export const DeleteSessionEndpoint = "/grpc/eraser.Eraser/DeleteSession";
  /**
   * DeleteSession deletes a single session given the session ID.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteSession(sender: (req: DeleteSessionRequest, endpoint: string) => Promise<OperationId>, req: DeleteSessionRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSessionEndpoint),
      endpoint: DeleteSessionEndpoint
    };
  }

  export const DeleteIndividualSegmentEndpoint = "/grpc/eraser.Eraser/DeleteIndividualSegment";
  /**
   * DeleteIndividualSegment deletes identified users and anonymous users that
   * belong to the segment identified by the given unnamed segment URL. Deletion
   * includes users' properties and users' sessions.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteIndividualSegment(sender: (req: DeleteIndividualSegmentRequest, endpoint: string) => Promise<OperationId>, req: DeleteIndividualSegmentRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIndividualSegmentEndpoint),
      endpoint: DeleteIndividualSegmentEndpoint
    };
  }

  export const RequestIndividualSegmentDeletionEndpoint = "/grpc/eraser.Eraser/RequestIndividualSegmentDeletion";
  /**
   * RequestSegmentDeletion creates the deletion request.
   * Once the request is approved with ReviewDeletion, the data is deleted.
   */
  export function RequestIndividualSegmentDeletion(sender: (req: DeleteIndividualSegmentRequest, endpoint: string) => Promise<OperationId>, req: DeleteIndividualSegmentRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, RequestIndividualSegmentDeletionEndpoint),
      endpoint: RequestIndividualSegmentDeletionEndpoint
    };
  }

  export const ReviewDeletionEndpoint = "/grpc/eraser.Eraser/ReviewDeletion";
  /**
   * ReviewDeletion lets a reviewer review a deletion request.
   * It executes the deletion request if approved, and discards it if denied.
   */
  export function ReviewDeletion(sender: (req: ReviewDeletionRequest, endpoint: string) => Promise<OperationId>, req: ReviewDeletionRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, ReviewDeletionEndpoint),
      endpoint: ReviewDeletionEndpoint
    };
  }

  export const DeleteSegmentEndpoint = "/grpc/eraser.Eraser/DeleteSegment";
  /**
   * DeleteSegment deletes sessions that belong to the segment identified by the
   * given unnamed segment URL. Deletes only the sessions, and does not include
   * any users' properties.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteSegment(sender: (req: DeleteSegmentRequest, endpoint: string) => Promise<OperationId>, req: DeleteSegmentRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSegmentEndpoint),
      endpoint: DeleteSegmentEndpoint
    };
  }

  export const RequestSegmentDeletionEndpoint = "/grpc/eraser.Eraser/RequestSegmentDeletion";
  /**
   * RequestSegmentDeletion creates the deletion request.
   * Once the request is approved with ReviewDeletion, the data is deleted.
   */
  export function RequestSegmentDeletion(sender: (req: DeleteSegmentRequest, endpoint: string) => Promise<OperationId>, req: DeleteSegmentRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, RequestSegmentDeletionEndpoint),
      endpoint: RequestSegmentDeletionEndpoint
    };
  }

  export const DeleteOrgEndpoint = "/grpc/eraser.Eraser/DeleteOrg";
  /**
   * DeleteOrg deletes all data including captured data and configurations associated with the org identified by the given org ID.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteOrg(sender: (req: DeleteByOrgRequest, endpoint: string) => Promise<OperationId>, req: DeleteByOrgRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteOrgEndpoint),
      endpoint: DeleteOrgEndpoint
    };
  }

  export const RequestOrgDeletionEndpoint = "/grpc/eraser.Eraser/RequestOrgDeletion";
  /**
   * RequestOrgDeletion creates the deletion request.
   * Once the request is approved with ReviewDeletion, the data is deleted.
   */
  export function RequestOrgDeletion(sender: (req: DeleteByOrgRequest, endpoint: string) => Promise<OperationId>, req: DeleteByOrgRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, RequestOrgDeletionEndpoint),
      endpoint: RequestOrgDeletionEndpoint
    };
  }

  export const DeleteCapturedDataEndpoint = "/grpc/eraser.Eraser/DeleteCapturedData";
  /**
   * DeleteCapturedData deletes all data including captured data and configurations associated with the org identified by the given org ID.
   * This is an asynchronous operation, and the response is an operation ID.
   */
  export function DeleteCapturedData(sender: (req: DeleteByOrgRequest, endpoint: string) => Promise<OperationId>, req: DeleteByOrgRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteCapturedDataEndpoint),
      endpoint: DeleteCapturedDataEndpoint
    };
  }

  export const RequestCapturedDataDeletionEndpoint = "/grpc/eraser.Eraser/RequestCapturedDataDeletion";
  /**
   * RequestCapturedDataDeletion creates the deletion request.
   * Once the request is approved with ReviewDeletion, the data is deleted.
   */
  export function RequestCapturedDataDeletion(sender: (req: DeleteByOrgRequest, endpoint: string) => Promise<OperationId>, req: DeleteByOrgRequest): { promise: () => Promise<OperationId>, endpoint: string } {
    return {
      promise: () => sender(req, RequestCapturedDataDeletionEndpoint),
      endpoint: RequestCapturedDataDeletionEndpoint
    };
  }

  export const CountSessionsBySegmentEndpoint = "/grpc/eraser.Eraser/CountSessionsBySegment";
  /**
   * CountSessionsBySegment returns the number of sessions and events matched by
   * the given segment URL, as well as the timestamps for the oldest and newest
   * matched events.
   * this endpoint is currently only used internally
   */
  export function CountSessionsBySegment(sender: (req: CountBySegmentRequest, endpoint: string) => Promise<CountSessionsBySegmentResponse>, req: CountBySegmentRequest): { promise: () => Promise<CountSessionsBySegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CountSessionsBySegmentEndpoint),
      endpoint: CountSessionsBySegmentEndpoint
    };
  }

  export const CountUsersBySegmentEndpoint = "/grpc/eraser.Eraser/CountUsersBySegment";
  /**
   * CountUsersBySegment returns the number of identified users (aka individuals)
   * and anonymous users (aka users) matched by the given segment URL, as well
   * as the number of sessions and events. It is important to note that the
   * number of events returned by this method is an approximation. For more
   * accurate number of sessions and events use CountSessionsBySegment instead.
   * this endpoint is currently only used internally
   */
  export function CountUsersBySegment(sender: (req: CountBySegmentRequest, endpoint: string) => Promise<CountUsersBySegmentResponse>, req: CountBySegmentRequest): { promise: () => Promise<CountUsersBySegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CountUsersBySegmentEndpoint),
      endpoint: CountUsersBySegmentEndpoint
    };
  }

  export const GetOperationStatusEndpoint = "/grpc/eraser.Eraser/GetOperationStatus";
  /** GetOperationStatus returns the status of the asynchronous operation. */
  export function GetOperationStatus(sender: (req: OperationId, endpoint: string) => Promise<fullstory_operations_v1.Operation>, req: OperationId): { promise: () => Promise<fullstory_operations_v1.Operation>, endpoint: string } {
    return {
      promise: () => sender(req, GetOperationStatusEndpoint),
      endpoint: GetOperationStatusEndpoint
    };
  }

  export const ListOperationsEndpoint = "/grpc/eraser.Eraser/ListOperations";
  /**
   * ListOperations returns a page of all asynchronous deletion operations for
   * an org. The response includes the operations' status, and a page token to
   * fetch more pages.
   */
  export function ListOperations(sender: (req: ListOperationsRequest, endpoint: string) => Promise<fullstory_operations_v1.ListOperationsResponse>, req: ListOperationsRequest): { promise: () => Promise<fullstory_operations_v1.ListOperationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListOperationsEndpoint),
      endpoint: ListOperationsEndpoint
    };
  }

  export const ReplayWorkflowEndpoint = "/grpc/eraser.Eraser/ReplayWorkflow";
  /** TODO(sanjay): Move to admin.proto */
  export function ReplayWorkflow(sender: (req: ReplayWorkflowRequest, endpoint: string) => Promise<{}>, req: ReplayWorkflowRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ReplayWorkflowEndpoint),
      endpoint: ReplayWorkflowEndpoint
    };
  }
}

export namespace Cron {

  export const DiscardStaleEndpoint = "/grpc/eraser.Cron/DiscardStale";
  export function DiscardStale(sender: (req: TimeAfterCreation, endpoint: string) => Promise<{}>, req: TimeAfterCreation): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DiscardStaleEndpoint),
      endpoint: DiscardStaleEndpoint
    };
  }

  export const SendDeletionEmailsEndpoint = "/grpc/eraser.Cron/SendDeletionEmails";
  export function SendDeletionEmails(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendDeletionEmailsEndpoint),
      endpoint: SendDeletionEmailsEndpoint
    };
  }
}

export interface IndividualId {
  /**
   * The unique user ID used by the org to identify the user, for example with
   * FS('setIdentity').
   */
  uid: string;
  orgId: string;
}

export interface DeleteIndividualRequest {
  /**
   * The unique user ID used by the org to identify the user, for example with
   * FS('setIdentity').
   */
  uid: string;
  orgId: string;
  skipEmail: boolean;
  note: string;
}

export interface UserId {
  orgId: string;
  /**
   * The autogenerated numeric identifier, typically used to identify an
   * anonymous user or a user on a device.
   */
  userId: protobuf.int64;
}

export interface DeleteUserRequest {
  orgId: string;
  /**
   * The autogenerated numeric identifier, typically used to identify an
   * anonymous user or a user on a device.
   */
  userId: protobuf.int64;
  skipEmail: boolean;
}

export interface DeleteIndividualSegmentRequest {
  /**
   * A FullStory app URL pointing to an unnamed segment, i.e. not a saved
   * segment.
   */
  segmentUrl: string;
  note: string;
}

export interface DeleteByOrgRequest {
  orgId: string;
  note: string;
}

export interface CountBySegmentRequest {
  /** The unnamed segment URL. */
  segmentUrl: string;
}

export interface CountSessionsBySegmentResponse {
  sessionsCount: protobuf.int64;
  eventsCount: protobuf.int64;
  minEventTime: protobuf.timestamp | null;
  maxEventTime: protobuf.timestamp | null;
}

export interface CountUsersBySegmentResponse {
  individualsCount: protobuf.int64;
  usersCount: protobuf.int64;
  sessionsCount: protobuf.int64;
  /**
   * The number of events in all of the sessions that belong to all of the users
   * that match the segment. Note that this is an approximate value.
   */
  eventsCount: protobuf.int64;
}

export interface ReplayWorkflowRequest {
  workflowId: string;
  runId: string;
}

export interface ReviewDeletionRequest {
  orgId: string;
  deletionId: string;
  approved: boolean;
  note: string;
}

export interface TimeAfterCreation {
  seconds: protobuf.int64;
}
